import Search from '@/frontend/components/qecomps/Search.tsx'
import { useEffect } from 'react'
import PrevNext from '@/frontend/components/menu/PrevNext.tsx'
import FormBack from '@/frontend/components/qecomps/FormBackMaker.ts'
import TotalIncome from '@/frontend/components/journal/TotalIncome.tsx'
import PayConfig, { UnitName } from '@/common/payment/PayConfig.ts'
import JournalWideItem from '@/frontend/components/explore/JournalWideItem.tsx'
import UniqueInterval from '@/frontend/components/qecomps/UniqueInterval.ts'
import Bold from '@/frontend/components/qecomps/Bold.tsx'
import Icon2Titles from '@/frontend/components/qecomps/Icon2Titles.tsx'
import Router from 'next/router'
import ReplacePro from '@/frontend/components/qecomps/ReplacePro.tsx'
import UserAvatar from '@/frontend/components/qecomps/UserAvatar.tsx'
import ServiceExpiration from '@/frontend/components/qecomps/ServiceExpiration.ts'
import CommentsOnScreen from '@/frontend/components/comment/CommentsOnScreen'
import dynamic from 'next/dynamic';
// const JournalWideItem = dynamic(() => import('@/frontend/components/explore/JournalWideItem.tsx').then(x => x.default), { ssr: false })
// const HeaderBar = dynamic(() => import('@/frontend/components/menu/HeaderBar.tsx').then(x => x.default), { ssr: false })
const Comments = dynamic(() => import('@/frontend/components/comment/Comments.tsx').then(x => x.default), { ssr: false })
// import CommentsButton from '@/frontend/components/explore/CommentsButton.tsx'
const CommentsButton = dynamic(() => import('@/frontend/components/explore/CommentsButton.tsx').then(x => x.default), { ssr: false })

import Component, { PageEl } from '@/frontend/components/qecomps/Component'

import GetJIDsComments from '@/backend/Tools/GetJIDsComments.ts'

export default p => Component(p, Page, true);
const Page: PageEl = (props: {} & { [key: string]: any }, refresh, getProps, onLoad, onConnected, dies, isFront, z) => {

  const GetComments = async (item) => {

    if (item.commentsfetched) {
      return
    }
    let json = await API["jcomment/comments"]({
      type: "get",
      lang: z.lang.code,
      jid: item.jid,
      skip: 0,
      limit: 600
    })
    if (item) {
      if (z.lang.code == "fa") {
        json.comments.sort((a, b) => {
          if (a.comment.startsWith("[VOICE:")) {
            return 0
          }
          if (a.comment.includes("پ") ||
            a.comment.includes("ژ") ||
            a.comment.includes("گ") ||
            a.comment.includes("ی") ||
            a.comment.includes("چ")) {
            return 0
          }
          if (a.comment.includes("ي") || a.comment.includes("ك") || a.comment.includes("أ")) {
            return 1
          }
          if (FAtoENRatio(a.comment) > 0) {
            return 0
          }
          return 1
        })
      }
      item.comments = json.comments
      item.commentsfetched = true
    }
  }

  if (props.query.tag) {
    props.followed = z.user.follows.includes(props.query.tag.replace(/-/g, "_").replace(/\s/g, "_"))
  }

  var interval = { run: () => { } }

  if (typeof window != "undefined") {
    props.iswide = window.innerWidth > 800
  }

  useEffect(() => {
    let loadedjournals = []


    if (window.location.href.replace(/#/g, "") != global.jpath) {
      global.jpath = window.location.href.replace(/#/g, "")
      global.document?.getElementById("wind")?.scrollTo({
        top: 0,
        behavior: 'smooth' // This creates a smooth scrolling effect, omit for instant scroll
      });
    }

    if (props.jid) {
      global.cache?.("jid-link", { jid: props.query.jid });
    }
    else if (props.onlytag) {
      global.cache?.("jidtag-tag", { tag: props.onlytag });
    }
    else if (props.query.s) {
      global.cache?.("jidtag-search", { tag: props.query.s.replace(/-/g, "_").replace(/\s/g, "_") })
    }
    else {
      global.cache?.("page", { page: "journal" })
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (entry.target.id.startsWith("jrndiv_")) {
            let id = entry.target.id.slice(7)
            if (!loadedjournals.includes(id)) {
              let i = props.items.find(it => it.jid == id)
              if (i) {
                GetComments(i).then(() => {
                  if (i.cmntrestate)
                    setTimeout(() => i.cmntrestate(), 200)
                })
                loadedjournals.push(id)
              }
            }
          }
        }
      });
    }, {
      root: document.getElementById("wind"),
      rootMargin: '0px',
      threshold: 0.1, // Adjust visibility threshold (e.g., 0.1 means 10% visible)
    });

    const elements = document.getElementById("journals")
    for (let child of elements.children) {
      if (child.id.startsWith("jrndiv_")) {
        observer.observe(child)
      }
    }



    UniqueInterval("jidinterval", () => {
      if (props.items && props.items.length > 0) {
        interval.run()
      }
    }, 200)
  })

  useEffect(() => {
    props.theme = global.theme
    refresh()
  }, [])


  if (!props.items) {
    props.items = []
  }

  if (!props.form) {
    FormBack.RemoveBackableForms("comments")
  }


  return (
    <div style={{ direction: z.lang.dir as any, minHeight: "110vh", maxWidth: "100vw", overflowX: "hidden" }}>


      <main className={z.styles.main}>

        <HeaderBar nopaths gototop
          defaultValue={(props.query.s || "").replace(/-/g, " ")}
        />
        <div className={z.styles.graybox}>
          <div style={{ width: "100%" }}>
            <div style={{ marginTop: 0 }}>


              {props.form == "comments" ? <Comments
                id={props.items && props.items[props.itemidx].jid}
                idkey="jid"
                title1={z.lang.jrnlcmnts}
                title3={z.lang.writedby + " " + props.items[props.itemidx]?.name}
                title2={TextEndAbbreviation(props.items[props.itemidx].title1, 40)}
                icon={props.items[props.itemidx].poster}
                restate={(r) => props.comment = r}
                isopen={true}
                item={props.items[props.itemidx]}
                onback={() => {
                  refresh({ form: null })
                }}
                iswide={props.iswide}
                show={true}
                onclose={() => {
                  refresh({ form: null })
                }}
                loginrequired={() => { props.loginrequired?.() }}
              /> : null}


              {/* {z.user?.email && !(
                props.expid || props.saves || props.jid || props.saves || props.onlytag || props.onlyuser
              ) ? <TotalIncome totalamount={props.totalamount.toLocaleString(z.lang.region)} items={props.items}
                onlymine={props.onlymine} waitings={props.waitings} /> : null} */}

              <f-cse style={{ overflowX: "scroll", padding: "0 10px", columnGap: 5, display: "none" }}>

                <b-100 className={z.styles.bg2} style={{ padding: 5, }}>
                  <icon class='w-[15px] h-[15px] text-red-700 icon-[tabler--live-photo-filled]' /><sp-3 />
                  <f-11>{"فوری"}</f-11>
                </b-100>


                <b-100 className={z.styles.bg2} style={{ padding: 5, }}>
                  <icon class='w-[15px] h-[15px] icon-[material-symbols--radar]' /><sp-3 />
                  <f-11>{"تکنولوژی"}</f-11>
                </b-100>

                <b-100 className={z.styles.bg2} style={{ padding: 5, }}>
                  <icon class='w-[15px] h-[15px] icon-[token--bitcoin]' /><sp-3 />
                  <f-11>{"مالی"}</f-11>
                </b-100>

                <b-100 className={z.styles.bg2} style={{ padding: 5, }}>
                  <icon class='w-[15px] h-[15px] icon-[fluent--person-support-24-regular]' /><sp-3 />
                  <f-11>{"سرگرمی"}</f-11>
                </b-100>

                <b-100 className={z.styles.bg2} style={{ padding: 5, }}>
                  <icon class='w-[15px] h-[15px] icon-[fluent--person-support-24-regular]' /><sp-3 />
                  <f-11>{"ویدیو"}</f-11>
                </b-100>

                <b-100 className={z.styles.bg2} style={{ padding: 5, }}>
                  <icon class='w-[15px] h-[15px] icon-[mingcute--science-line]' /><sp-3 />
                  <f-11>{"علمی"}</f-11>
                </b-100>

                <b-100 className={z.styles.bg2} style={{ padding: 5, }}>
                  <icon class='w-[15px] h-[15px] icon-[charm--graduate-cap]' /><sp-3 />
                  <f-11>{"آموزش"}</f-11>
                </b-100>


              </f-cse>
              <br-xx />

              {props.expid ? <>
                <Icon2Titles raw
                  title1={<f-11>
                    <Bold>{z.lang.service + ": " + props.title1}</Bold></f-11>}
                  style={{ backgroundColor: "#97b8c5", height: 45 }}
                  onclose={() => {
                    Router.push(z.root)
                  }} /><br-xx /></> : null}

              {props.saves ? <><br-xxx />
                <Icon2Titles raw
                  class={z.styles.bg1}
                  icon={<Img src={global.cdn("/files/saved.svg")} style={{ width: 15, height: 15 }} />}
                  title1={<f-11>{z.lang.onlysvjrnl}</f-11>}
                  style={{ backgroundColor: "#97b8c5", height: 45 }}
                  onclose={() => Router.push(z.root)} />
              </> : null}


              {props.onlytag && props.query.tag ? <><br-xxx />{Tag(props, refresh, z)}</> : null}

              {props.onlyuser ? <><br-xxx />
                <Icon2Titles raw
                  title1={
                    <f-c>
                      <f-11>
                        {ReplacePro(z.lang.onlyshowjrnluid, "XX",
                          <span style={{ display: "inline-block" }}>
                            <UserAvatar image={props.onlyuser.image} imageprop={props.onlyuser.imageprop} width={20}
                              style={{ display: "inline-block", verticalAlign: "middle", margin: "0 5px" }} />
                            <Bold>{props.onlyuser.name}</Bold>
                          </span>)}
                      </f-11>
                    </f-c>
                  }
                  class={z.styles.bgbluepale}
                  style={{ height: 40, marginBottom: 2 }}
                  onclose={() => { props.onlyuser = null; Router.push(z.root) }} /></> : null
              }


              {/* <br-xx /> */}

              <div id={"journals"} className={z.styles.bg1} style={{ borderRadius: 5 }}>

                {props.query.tag ? <h1 className={z.styles.none}>{props.query.tag.replace(/-/g, " ")}</h1> : null}
                {/* {props.items?.length == 1 ? <h1 className={z.styles.none}>{props.items[0].title1}</h1> : null} */}

                {/* {props.items.length == 1 ? <figure className={z.styles.none}>
                  <img src={props.mainimage} alt={props.items[0].title1} loading='eager' />
                  <figcaption>{props.items[0].title1}</figcaption>
                  {props.items[0].video ? <video src={props.items[0].video} className={z.styles.none}
                    aria-label={props.items[0].title1} ></video> : null}
                </figure> : null} */}

                {props.items.map((item, i) => {
                  return <div id={"jrndiv_" + item.jid} key={item.jid}>
                    <div style={{ fontSize: 12 }}>

                      {i > 0 ? <><br-xx /><hr className='h-[1px] bg-[#00000022]' /><br-xx /></> : null}

                      <Icon2Titles
                        raw
                        class={z.styles.bgbluepale}
                        on={() => { global.vplay?.() }}
                        icon={
                          <Img src={cdn(`/files/cat/${props.theme || "dark"}/${z.lang.code}/${item.type}.webp`)} style={{ height: 30, width: 68 }} className='transform scale-x-[1]' />
                        }
                        title1={<h1 style={{ lineHeight: 1.5 }}><Bold>{item.title1}</Bold></h1>}
                        style={{ height: 45 }}
                      />



                      <JournalWideItem
                        item={item}
                        items={props.items}
                        onreload={(e) => { refresh() }}
                        index={i}
                        iswide={props.iswide}
                        interval={interval}
                        onnameclick={(uid) => { Router.push(z.root + "?uid=" + uid) }}
                        onavatarclick={(uid) => { Router.push(z.root + "?uid=" + uid) }}
                        oncomments={async () => {
                          global.cache?.("jid-comment", { jid: item.jid })
                          FormBack.MakeBackableForm("comments", () => { refresh({ form: null }) });
                          refresh({ form: "comments", itemidx: i });
                          if (item.comments.length < 35) {

                            let json = await API["jcomment/comments"]({
                              type: "get",
                              lang: z.lang.code,
                              jid: item.jid,
                              skip: 30,
                              limit: 60
                            })


                            if (json.code == 0) {
                              item.comments.unshift(...json.comments)
                            }
                          }
                        }}

                      />
                      <br-xx />
                      {!props.iswide ? <CommentsButton
                        iswide={props.iswide}
                        restate={r => {
                          item.cmntrestate = r;
                        }}
                        item={props.items?.[i] || props.items?.[i]} on={async () => {

                          FormBack.MakeBackableForm("comments", () => { refresh({ form: null }) });
                          refresh({ form: "comments", itemidx: i });
                          if (item.comments.length < 35) {
                            let json = await API["jcomment/comments"]({
                              type: "get",
                              lang: z.lang.code,
                              jid: item.jid,
                              skip: 30,
                              limit: 60
                            })

                            if (json.code == 0) {
                              item.comments.unshift(...json.comments)
                            }
                          }
                        }} /> : null}


                    </div>

                  </div>
                })}

                <br-x />


                <CommentsOnScreen
                  id={props.items && props.items[0].jid}
                  idkey="jid"
                  title1={z.lang.jrnlcmnts}
                  title3={z.lang.writedby + " " + props.items[0]?.name}
                  title2={TextEndAbbreviation(props.items[0].title1, 40)}
                  icon={props.items[0].poster}
                  restate={(r) => props.comment = r}
                  isopen={true}
                  item={props.items[0]}
                  onback={() => {
                    refresh({ form: null })
                  }}
                  iswide={true}
                  show={true}
                  onclose={() => {
                    refresh({ form: null })
                  }}
                  loginrequired={() => { props.loginrequired?.() }}
                />


                <br-x />
                {/* <f-14 className="px-3 bold"><Bold>{z.lang.readmore}:</Bold></f-14> */}
                <br-x />
                <w-c style={{ gap: 5, paddingRight: 4, paddingLeft: 4 }}>

                  {props.more.map(item => {
                    return <Link href={z.root + "/" + item.key} style={{ textDecoration: "none" }}><Icon35Titles
                      title1={item.title1}
                      alt={item.title1}
                      title2={Cap(z.lang[item.type])}
                      title3={<f-cc>
                        <icon style={{ opacity: 0.7, marginTop: 2 }} class='w-[15px] h-[15px] icon-[mingcute--eye-2-fill]' />
                        <sp-4 />
                        {
                          (item.views).toLocaleString(z.lang.region)
                        }</f-cc>}
                      icon={cdn(item.poster)} on={async () => {
                      }} /></Link>
                  })}

                </w-c>



                {props.items.length > 0 ? <PrevNext total={props.pages} on={() => {
                  props.items = null
                  // refresh()
                  // global.document?.getElementById("wind")?.scrollTo({
                  //   top: 0,
                  //   // behavior: 'smooth' // This creates a smooth scrolling effect, omit for instant scroll
                  // });
                }} /> : null}


                <br-x />
                <br-x />
                <br-x />
                <br-x />
                {props.items.length == 0 ? <f-cc><Img src={cdn("/files/notfound.webp")} style={{ width: 40, height: 40 }} /></f-cc> : null}
                <br-x />
                <br-x />
                <br-x />
                <br-x />
                <br-x />


              </div>
            </div>
            <br />
          </div>
        </div>
      </main>

      <FloatingBall />
    </div>
  )
}

function generateRegexFromArray(array) {
  const escapedArray = array.map(item => item.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const regexPattern = escapedArray.join('|');
  return new RegExp(regexPattern, 'i'); // 'i' for case-insensitive
}


const AddView = (jid) => {
  if (process.env.CDN != "0") {
    if (!global.jidsviews) {
      global.jidsviews = {};
    }

    if (!global.jidsviews[jid])
      global.jidsviews[jid] = 1;
    else
      global.jidsviews[jid]++;
  }
}


import type { GetServerSideProps, GetServerSidePropsContext } from 'next';
import rolecheck from '@/common/rolecheck.ts'
import Cacher from '@/backend/Cacher.ts'
import TextEndAbbreviation from '@/frontend/components/qecomps/TextEndAbbreviation.ts'
import Tag from '@/frontend/components/ribbon/Tag.tsx'
import WindowFloat from '@/frontend/components/qecomps/WindowFloat.tsx'
import { size } from 'fancy-canvas'
import Cap, { FAtoENRatio } from '@/frontend/components/qecomps/Cap.ts'
import Icon3Titles from '@/frontend/components/qecomps/Icon3Titles.tsx'
import Icon35Titles from '@/frontend/components/qecomps/Icon35Titles.tsx'
import Img from '@/frontend/components/qecomps/Img.tsx'
import FloatingBall from '@/frontend/components/menu/FloatingBall.tsx'
import { LDJSONArticle, LDJSONOrganization, LDJSONVideo, LDJSONWebPage, LDJSONWebSite, Meta, toLocalISO } from '@/common/seo.ts'
import HeaderBar from '@/frontend/components/menu/HeaderBar.tsx'
import Link from 'next/link'
import SiteConfig from '@/common/SiteConfig'


export const getServerSideProps: GetServerSideProps = async (context: GetServerSidePropsContext) => {


  (global.Startup != "OK") ? (await (await import('@/startup.ts')).Starter()) : null;

  var { email, lang, uid, userip, role, session, follows, pageid, cacher, jsaves, esaves } = await global.SSRVerify(context, !global.devmode)

  console.log(context.query)

  // console.log("JOURNAL QUERY:", context.query)
  // console.log("JOURNAL URL:", context.resolvedUrl)


  if (cacher) {
    return cacher
  }


  let keys = ["expassign", "edit", "more", "journalmaxlen", "code", "pages", "region", "dir", "txtmt", "ff", "ffb", "andxcmnts",
    "delete", "plzvote", "relserv", "support", "transactions", "viewxreplies", "viewxmorereplies", "account", "loginreg", "sendmsg",
    "ctrlpanel", "myapps", "homeexplore", "explore", "deposit", "transfer", "withdraw", "transactions", "messages", "logout", "from",
    "login", "loginreg", "logingoogle", "loginlinkedin", "orloginemail", "emailisnotvalid", "followed", "onlyshowjrnluid", "copylink",
    "emailisempty", "plzenturemail", "hmverfy", "backtopreviouspage", "confirm", "onlyjrnltag", "follow", "unfollow", "getservice",
    "unpin", "pin", "pinned", "leaveacomment", "firstcomment", "morecomments", "comments", "service", "qeplayer", "searchexample",
    "usersuccess", "news", "video", "journal", "tutorial", "languagename", "path", "reply", "translate"]
  if (context.query.jid) {
    keys.push("onlyjid")
  }
  if (context.query.uid) {
    keys.push("onlyshowjrnluid")
  }

  let nlangs = {}
  for (let l of Object.keys(global.langs[lang])) {
    if (keys.includes(l))
      nlangs[l] = global.langs[lang][l]
  }

  // console.log(global.langs[lang])
  var u = global.db.collection("users");
  var h = global.db.collection("journals");
  var e = global.db.collection("explore");
  var c = global.db.collection("chats");
  var s = global.db.collection("services");

  let myservs = await s.find({ uid }).toArray();
  myservs.filter(service => service.status == "approved" || service.status == "freezed");
  myservs.filter(service => !ServiceExpiration(service).expired);

  let tagregex = new RegExp("")

  if (follows) {
    tagregex = generateRegexFromArray(follows)
  }

  let tagq = context.query.tag as string;
  let jidq = null;
  let sq = null;

  let isqueryid = false;
  var explore: any = {}

  // console.log("QUERY: ", context.query)



  if (context.query.jid) {

    let b64 = Buffer.from((context.query.jid || "") as string, 'base64').toString('hex')
    let validb64 = false;//global.ObjectId.isValid(b64)
    var orobj = [];
    global.langlist.forEach(async l => {
      if (global.ObjectId.isValid(context.query.jid.toString())) {
        isqueryid = true;
        AddView(context.query.jid);
        jidq = ObjectId.createFromHexString(context.query.jid.toString())
      }
      else {
        if (validb64) {
          jidq = ObjectId.createFromHexString(b64.toString())
          AddView(b64);
        }
        else {
          tagq = ((context.query.tag || "") as string).replace(/-/g, "_").replace(/\s/g, "_")
        }
      }
    })
    explore = { $or: orobj }
  }





  if (context.query.s) {
    sq = context.query.s
  }


  let q: any = {
    $and: [
      { $or: [{ uid }, { status: "published" }] },
    ]
  };

  if (context.query.expid) {
    q.expid = ObjectId.createFromHexString(context.query.expid.toString())
  }

  if (sq) {

    sq = sq.replace(/ـ/g, " ").replace(/_/g, " ").replace(/-/g, " ")
    let words = sq.split(" ")

    let and = []
    for (let w of words) {
      let or = []
      or.push({ ["langs." + global.langs[lang].code + ".comment"]: { $regex: w, $options: 'i' } })
      or.push({ ["langs." + global.langs[lang].code + ".tags"]: { $regex: w, $options: 'i' } })
      or.push({ ["langs.en.tags"]: { $regex: w, $options: 'i' } })
      or.push({ ["langs.en.comment"]: { $regex: w, $options: 'i' } })
      and.push({ $or: or })
    }

    q = { $and: and }


    global.db.collection("search").findOne({ s: sq }).then(async r => {
      let s = global.db.collection("search")
      if (r) {
        let update = { $inc: { count: 1 } }
        if (uid) {
          update["$addToSet"] = { uid }
        }
        await s.updateOne({ _id: r._id }, update)
      }
      else {
        let insert = { s: sq, count: 1 }
        if (uid) {
          insert["uid"] = [uid]
        }
        await s.insertOne(insert);
      }
    })
  }


  if (tagq) {

    tagq = decodeURIComponent(tagq);

    let sq1 = tagq.toString().replace(/ـ/g, "_")
    let sq2 = tagq.toString().replace(/_/g, "ـ")
    let sq3 = tagq.toString().replace(/-/g, "_")

    q["$and"].push({
      $or: [
        { "langs.fa.tags": { $regex: tagq, $options: 'i' } },
        { "langs.fa.tags": { $regex: sq1, $options: 'i' } },
        { "langs.fa.tags": { $regex: sq2, $options: 'i' } },
        { "langs.en.tags": { $regex: tagq, $options: 'i' } },
        { [`langs.${lang}.tags`]: { $regex: tagq, $options: 'i' } },
        { [`langs.${lang}.tags`]: { $regex: sq3, $options: 'i' } },
      ]
    })




    global.db.collection("search").findOne({ t: tagq }).then(async r => {
      let s = global.db.collection("search")
      if (r) {
        let update = { $inc: { count: 1 } }
        if (uid) {
          update["$addToSet"] = { uid }
        }
        await s.updateOne({ _id: r._id }, update)
      }
      else {
        let insert = { t: tagq, count: 1 }
        if (uid) {
          insert["uid"] = [uid]
        }
        await s.insertOne(insert);
      }
    })

  }



  if (context.query.uid) {
    q["uid"] = ObjectId.createFromHexString(context.query.uid.toString())
  }

  if (context.query.key) {
    q["key"] = context.query.key
  }


  if (jidq) {
    q["jid"] = jidq
  }

  if (context.query.waitings) {
    q.status = "waiting"
  }
  let me = email ? await u.findOne({ uid }) : null
  if (me && context.query.saves) {
    let jids = Object.keys(me.jsaves || {}).map(j => ObjectId.createFromHexString(j.toString()))
    q["jid"] = { $in: jids }
  }


  let myexpids = myservs.map(s => s.expid)
  q["$and"].push({
    $or: [
      { private: { $ne: true } },
      { uid },
      { expid: { $in: myexpids } },
      { expid: { $exists: false } }
    ]
  })

  q.hidden = { $ne: true }

  let tagpinns = [];

  if (!sq && !tagq) {
    let conds = []
    for (let tag of follows) {
      conds.push({ [`langs.${lang}.tags`]: { $regex: tag } })
    }
    q["$and"].push({ $or: [{ "indexed": true }, ...conds] });
  }
  else {
    tagpinns = await h.find({ ...q, tagpinned: true }).sort({ date: -1 }).project({ _id: 0 }).toArray();
    q["tagpinned"] = { $ne: true }
  }



  var count: any = await h.countDocuments(q)
  var maxitemsperpage = 5;
  var pages = Math.ceil(count / maxitemsperpage)
  var page = (Number(context.query.page) || 1)
  page--;



  let pinquery: any = { pinned: true }
  let pinend = [];

  if (!sq && me?.unpinjrn?.length > 0) {
    pinquery.jid = { $nin: me.unpinjrn }
  }

  if (Object.keys(context.query).length == 0) {
    pinend = await h.find(pinquery).sort({ date: -1 }).project({ _id: 0 }).toArray();
    q["pinned"] = { $ne: true }
  }


  let journals = [];

  let proj = { _id: 0 };
  let unset = []
  for (let l of global.langlist) {
    if (l.code != lang
      // && l.code != "en"
    ) {
      proj[`langs.${l.code}`] = 0
      unset.push(`root.langs.${l.code}`)
    }
  }
  // if (lang != "en") {
  // unset.push("root.langs.en.comment")
  // }

  // console.log("UNSETS:", unset)

  // if (follows.length == 0) {
  //   journals = await h.find(q).sort({ date: context.query.sort ? 1 : -1 }).skip(page * maxitemsperpage).
  //     limit(maxitemsperpage).project(proj).toArray();
  // }
  // else {

  let or = []

  if (follows?.length > 0) {
    or.push({
      $regexMatch: {
        input: `$langs.${lang}.tags`,
        regex: tagregex,
      }
    })

    or.push({
      $regexMatch: {
        input: `$langs.en.tags`,
        regex: tagregex,
      }
    })
  }


  q["$or"] = [{ uid }, { "$and": q["$and"] }]

  delete q["$and"]
  console.log("QUERY:", q)

  journals = await h.aggregate([
    { $match: q },
    {
      "$project": {
        _id: 0, "root": "$$ROOT",
        weight: {
          $let: {
            vars:
            {
              mine: {
                $cond: [{ "$ne": ["$status", "published"] }, 0, -1]
              },
              follow: {
                $cond: [{
                  $or: or
                }, 1, 0]
              },
              type: {
                $cond: [{
                  $or: [{ "$eq": ["$type", "journal"] }, { "$eq": ["$type", "usersuccess"] }]
                }, 1, 0]
              },
            },
            in: { $add: ["$$follow", "$$type", "$$mine"] }
          }
        },
      },
    },
    { $unset: unset },
    { "$sort": { "weight": -1, "root.z": -1, "root.date": -1, } },
    { $skip: page * maxitemsperpage },
    { "$limit": maxitemsperpage },
  ]).toArray();



  journals = journals.map(it => {
    it.root.followidxs = []
    for (let l of global.langlist) {
      for (let i in follows) {
        if (new RegExp(follows[i], "i").test(it.root.langs[l.code]?.tags || "")) {
          if (!it.root.followidxs.includes(i))
            it.root.followidxs.push(i)
        }
      }
    }
    return it.root
  })
  // }


  journals = [...pinend, ...tagpinns, ...journals];

  if (journals.length == 0) {

  }


  for (let jrnl of journals) {
    jrnl.poster = (jrnl.langs[lang] || jrnl.langs.en || jrnl.langs.fa)?.poster
    jrnl.video = (jrnl.langs[lang] || jrnl.langs.en || jrnl.langs.fa)?.video
    jrnl.iframe = (jrnl.langs[lang] || jrnl.langs.en || jrnl.langs.fa)?.iframe
    jrnl.subtitle = (jrnl.langs[lang] || jrnl.langs.en || jrnl.langs.fa)?.subtitle
    jrnl.comment = (jrnl.langs[lang] || jrnl.langs.en || jrnl.langs.fa)?.comment
    jrnl.title1 = (jrnl.langs[lang] || jrnl.langs.en || jrnl.langs.fa)?.title1
    jrnl.titles = (jrnl.langs[lang] || jrnl.langs.en || jrnl.langs.fa)?.titles
    jrnl.tags = (jrnl.langs[lang] || jrnl.langs.en || jrnl.langs.fa)?.tags
  }

  // console.log(journals);


  let title1, title2, expimg;
  if (context.query.expid) {
    let exp = await e.findOne({ expid: ObjectId.createFromHexString(context.query.expid.toString()) })
    if (exp) {
      title1 = exp.langs[lang].title1
      title2 = exp.langs[lang].title2
      expimg = exp.langs[lang].icon
    }
  }

  let uids = journals.map(x => x.uid);
  if (context.query.uid && global.ObjectId.isValid(context.query.uid.toString())) {
    uids.push(ObjectId.createFromHexString(context.query.uid.toString()))
  }
  let users = journals.length == 0 ? [] : await u.find({ uid: { $in: uids } }).project({
    name: 1, image: 1, imageprop: 1, uid: 1, role: 1, verify: 1
  }).toArray()

  journals = journals.map(it => {
    let user = users.find(l => l.uid.equals(it.uid));
    it["name"] = user?.name || "Deleted user";;
    it["avatar"] = user?.image || global.cdn("/files/logocircular.webp");
    it["imageprop"] = user?.imageprop;

    if (rolecheck(user.role, ["admin", "journal"])) {
      it["verify"] = "admin"
    }
    else {
      it["verify"] = user?.verify;
    }

    return it
  })

  let onlyuser = users.find(us => us.uid.toString() == context.query.uid)
  if (onlyuser) {
    onlyuser = {
      name: onlyuser.name, image: onlyuser.image || global.cdn("/files/user.svg"),
      imageprop: onlyuser.imageprop,
      verify: rolecheck(onlyuser?.role, ["admin", "journal"]) ? "admin" : onlyuser?.verify || null
    }
  }

  let expids = journals.map(x => x.expid ? ObjectId.createFromHexString(x.expid.toString()) : null);
  let explores = journals.length == 0 ? [] : await e.find({ expid: { $in: expids } })
    .project({ ["langs." + lang]: 1, expid: 1, journal: 1, journalwallets: 1, commentscollection: 1, commentscount: 1, app: 1 }).toArray()
  explores = explores.map(it => {
    return {
      expid: it.expid,
      title1: it.langs[lang]["title1"],
      title2: it.langs[lang]["title2"],
      icon: it.langs[lang]["icon"],
      journal: it.journal,
      app: it.app,
      journalwallets: it.journalwallets,
      commentscollection: it.commentscollection,
      commentscount: it.commentscount,
    }
  })



  let journalids = journals.map(x => x.jid);
  let chats = journals.length == 0 ? [] : await c.find({ uid, jid: { $in: journalids }, status: { $ne: "closed" } }).project({ chatid: 1, jid: 1 }).toArray()


  journals = journals.map(it => {
    let exp = explores.find(e => e.expid.equals(it.expid))
    it.expitem = exp;
    if (!it.title1) {
      it.title1 = exp?.title1 || ""
    }
    if (context.query.saves) {
      it.saved = true;
    }
    return it;
  });

  journals = journals.map(it => {
    let chat = chats.find(e => e.jid.equals(it.jid))
    if (chat)
      it.chatid = chat.chatid.toString()
    return it;
  });


  let myjournals = journals.length == 0 ? [] : await h.find({ uid }).project({ wallet: 1, amount: 1 }).toArray();

  let totalamount = 0;
  if (myjournals.length > 0) {
    const P = PayConfig(global.langs[lang]);

    for (let item of myjournals) {
      let unit = P.wallets[item.wallet]?.unit
      let amountusd = (item.amount || 0) * unit.tousd;
      let amountlocal = amountusd / P.units[session.user.unit as UnitName].tousd;
      totalamount += amountlocal
    }
    // totalamount = z.user.unit.tolocalstr(totalamount);
  }

  // await GetJIDsComments(uid, journals, explores, role, 10000, lang)

  if (journals.length > 1) {
    for (let i = 0; i < journals.length; i++) {
      let explore = journals[i].expid ? explores.filter(ex => ex.expid.toString() == journals[i].expid.toString()) : []
      if (i < 5) {
        await GetJIDsComments(uid, [journals[i]], explore, role(["admin", "comment"]), 5, lang)
      }
      journals[i].commentscount = (journals[i].commentscount || 0) + (explore.length > 0 ? (explore[0].commentscount || 0) : 0)
    }
  }
  else if (journals.length == 1) {
    let i = 0;
    let explore = journals[i].expid ? explores.filter(ex => ex.expid.toString() == journals[i].expid.toString()) : []
    if (i < 5) {
      await GetJIDsComments(uid, [journals[i]], explore, role(["admin", "comment"]), 20, lang)
    }
    journals[i].commentscount = (journals[i].commentscount || 0) + (explore.length > 0 ? (explore[0].commentscount || 0) : 0)
  }


  let jids = journals.map(x => x.jid);
  let myjournalvotes = journals.length == 0 ? [] : await global.db.collection("votes").find({ uid, jid: { $in: jids } }).project({ _id: 0 }).toArray();
  journals = journals.map(it => {
    let myvote = myjournalvotes.find(l => l.jid.equals(it.jid));
    it["myvote"] = myvote?.vote;
    return it
  })

  journals = journals.map((it, i) => { //filter if he's not owner or role
    if (!uid || (!role(["admin", "journal"]) && (!uid.equals(it.uid)))) {
      delete it.wallet
      delete it.paid
      delete it.amount
      delete it.journalwallets
    }
    it.index = i
    return it
  })

  for (let jr of journals) {
    AddView(jr.jid);
    if (jsaves.includes(jr.jid.toString()))
      jr.saved = true
  }


  // let title = global.langs[lang]?.pages?.journals?.title
  // let description = global.langs[lang]?.pages?.journals?.description
  // let qe = lang == "fa" ? "کیو ای" : "QE"
  // let mainimage = "https://cdn.qepal.com/qepal/logocircular.webp"
  // if (tagq) {
  //   title = qe + " | " + tagq.replace(/_/g, " ").replace(/-/g, " ")
  // }
  // else if (sq) {
  //   title = qe + " | " + sq.replace(/_/g, " ").replace(/-/g, " ")
  // }
  // else if (isqueryid && journals[0]) {
  //   title = qe + " | " + journals[0].title1
  //   description = journals[0].comment
  // }

  // if (journals.length == 1) {
  //   title = qe + " | " + journals[0].title1
  //   description = journals[0].comment
  //   mainimage = cdn(journals[0].poster)
  // }

  // let endtime = new Date().getTime();
  // console.log("JOURNAL TIME CONSUME:", (endtime - starttime) + "ms")
  // console.log("JOURNAL TIME CONSUME:", (endtime - starttime) + "ms")


  // console.log("JOURNAL ITEM COUNT:", journals.length)

  let more = await h.find({ jid: { $nin: journals.map(j => j.jid) }, indexed: true }).sort({ _id: -1 }).limit(12).project({
    [`langs.${lang}.poster`]: 1,
    [`langs.${lang}.title1`]: 1,
    [`langs.${lang}.comment`]: 1,
    key: 1,
    jid: 1,
    views: 1,
    type: 1,
    _id: 0,
  }).toArray() as any


  more = more.map(item => {
    return {
      poster: item.langs[lang].poster,
      title1: item.langs[lang].title1,
      comment: item.langs[lang].comment.replaceAll("#", "").replaceAll("_", " "),
      jid: item.jid,
      key: item.key,
      type: item.type,
      views: item.views || 0,
    }
  })

  let meta: Meta = {} as any;

  if (journals.length == 1) {
    meta.title = journals[0].title1
    meta.description = journals[0].comment.replaceAll("#", "").replaceAll("_", " ");
    meta.canonical = `https://qepal.com/${lang}/${journals[0].key}`
    meta.hrefLangs = [
      { code: "fa", url: `https://qepal.com/fa/${journals[0].key}` },
      { code: "en", url: `https://qepal.com/en/${journals[0].key}` },
      { code: "de", url: `https://qepal.com/de/${journals[0].key}` },
      { code: "fr", url: `https://qepal.com/fr/${journals[0].key}` },
      { code: "es", url: `https://qepal.com/es/${journals[0].key}` },
      { code: "id", url: `https://qepal.com/id/${journals[0].key}` },
      { code: "ko", url: `https://qepal.com/ko/${journals[0].key}` },
      { code: "ja", url: `https://qepal.com/ja/${journals[0].key}` },
      { code: "zh", url: `https://qepal.com/zh/${journals[0].key}` },
      { code: "tr", url: `https://qepal.com/tr/${journals[0].key}` },
      { code: "ur", url: `https://qepal.com/ur/${journals[0].key}` },
      { code: "pt", url: `https://qepal.com/pt/${journals[0].key}` },
      { code: "ar", url: `https://qepal.com/ar/${journals[0].key}` },
      { code: "ru", url: `https://qepal.com/ru/${journals[0].key}` },
      { code: "x-default", url: `https://qepal.com/fa/${journals[0].key}` },
    ]

    if (lang == "fa" || lang == "en") {
      meta.index = true;
      meta.follow = true;
    }
    else {
      meta.index = false;
      meta.follow = false;
    }
    meta.og = {
      title: journals[0].title1,
      description: meta.description,
      image: cdn(journals[0].poster),
      alt: journals[0].title1,
      locale: "fa_IR",
      type: "article",
      url: "https://qepal.com/fa/" + journals[0].key
    }
    meta.twitter = {
      card: cdn(journals[0].poster),
      description: meta.description,
      image: cdn(journals[0].poster),
      site: "@qepal",
      title: journals[0].title1
    }

    meta.ldjsons = [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": SiteConfig.meta[lang].title,
        "url": "https://qepal.com",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://qepal.com/fa/s/{search_term_string}",
          "query-input": "required name=search_term_string"
        }
      } as LDJSONWebSite,

      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": SiteConfig.meta[lang].title,
        logo: "https://cdn.qepal.com/qepal/qecircabs.webp",
        contactPoint: { "@type": "ContactPoint", telephone: "+98-21-74391640", areaServed: { "@type": "Country", "name": "IR" } },
        url: "https://qepal.com/",
        sameAs: ["https://www.instagram.com/qenews", "https://x.com/armincdn", "https://www.linkedin.com/in/armin-kardan"]
      } as LDJSONOrganization,
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": journals[0].title1,
        "image": cdn(journals[0].poster),
        "url": "https://qepal.com/fa/" + journals[0].key,
        inLanguage: "fa",
        isPartOf: {
          "@type": "WebSite",
          "name": SiteConfig.meta[lang].title,
          "url": "https://qepal.com/"
        },
        mainEntity: {
          "@type": "Article",
          headline: journals[0].title1,
          image: [cdn(journals[0].poster)],
          author: { "@type": "Person", "name": "Ethan Cardan", url: "https://qepal.com" },
          dateModified: toLocalISO(new Date(journals[0].date)),
          datePublished: toLocalISO(new Date(journals[0].date)),
          description: meta.description,
          publisher: {
            "@type": "Organization",
            "name": SiteConfig.meta[lang].title,
            "logo": { "@type": "ImageObject", url: "https://cdn.qepal.com/qepal/qecircabs.webp" }
          }
        } as LDJSONArticle,
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": "https://qepal.com/fa/" + journals[0].key
        }
      } as LDJSONWebPage,



    ]

    if (journals[0].video) {
      meta.ldjsons.push({
        "@context": "https://schema.org",
        "@type": "VideoObject",
        "name": journals[0].title1,
        "description": meta.description,
        "thumbnailUrl": cdn(journals[0].poster),
        "uploadDate": toLocalISO(new Date(journals[0].date)),
        "duration": "PT2M30S",
        "contentUrl": cdn(journals[0].video),
        // "embedUrl": "https://www.youtube.com/embed/abc123xyz",
        publisher: {
          "@type": "Organization",
          "name": SiteConfig.meta[lang].title,
          "logo": { "@type": "ImageObject", url: "https://cdn.qepal.com/qepal/qecircabs.webp" }
        }
      } as LDJSONVideo)
    }
  }

  else {

    meta.title = SiteConfig.meta[lang].title
    meta.description = SiteConfig.meta[lang].description
    meta.canonical = "https://qepal.com/fa"
    meta.hrefLangs = [
      { code: "fa", url: `https://qepal.com/fa` },
      { code: "en", url: `https://qepal.com/en` },
      { code: "de", url: `https://qepal.com/de` },
      { code: "fr", url: `https://qepal.com/fr` },
      { code: "es", url: `https://qepal.com/es` },
      { code: "id", url: `https://qepal.com/id` },
      { code: "ko", url: `https://qepal.com/ko` },
      { code: "ja", url: `https://qepal.com/ja` },
      { code: "zh", url: `https://qepal.com/zh` },
      { code: "tr", url: `https://qepal.com/tr` },
      { code: "ur", url: `https://qepal.com/ur` },
      { code: "pt", url: `https://qepal.com/pt` },
      { code: "ar", url: `https://qepal.com/ar` },
      { code: "ru", url: `https://qepal.com/ru` },
      { code: "x-default", url: `https://qepal.com/fa` },
    ]
    if (lang == "fa" || lang == "en") {
      meta.index = true;
      meta.follow = true;
    }
    else {
      meta.index = false;
      meta.follow = false;
    }
    meta.og = {
      title: meta.title,
      description: meta.description,
      image: "https://cdn.qepal.com/qepal/qecircabs.webp",
      alt: meta.title,
      locale: "fa_IR",
      type: "website",
      url: "https://qepal.com"
    }

    meta.twitter = {
      card: "https://cdn.qepal.com/qepal/qecircabs.webp",
      description: meta.description,
      image: "https://cdn.qepal.com/qepal/qecircabs.webp",
      site: "@qepalcom",
      title: meta.title
    }

    meta.ldjsons = [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": meta.title,
        "url": "https://qepal.com",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://qepal.com/fa/s/{search_term_string}",
          "query-input": "required name=search_term_string"
        }
      } as LDJSONWebSite,
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": meta.title,
        logo: "https://cdn.qepal.com/qepal/qecircabs.webp",
        contactPoint: { "@type": "ContactPoint", telephone: "+98-21-74391640", areaServed: { "@type": "Country", "name": "IR" } },
        url: "https://qepal.com/",
        sameAs: ["https://www.instagram.com/qenews", "https://x.com/armincdn", "https://www.linkedin.com/in/armin-kardan"]
      } as LDJSONOrganization,
    ]
  }

  // console.log(journals[0])

  if (journals.length == 0) {
    return { notFound: true, props: {} }
  }


  let pr = await Prosper({
    props: {
      items: journals,
      more,
      query: { ...context.query, path: session.path },
      jidq,
      s: context.query.s || sq,
      expid: context.query.expid,
      title1, title2, expimg,
      onlymine: context.query.onlymine,
      waitings: context.query.waitings,
      totalamount,
      pages,
      session,
      onlytag: tagq,
      onlyuser,
      saves: context.query.saves,
      jid: context.query.jid,
      nlangs, pageid,
      // title,
      // description,
      mainimage: cdn(journals[0].poster),
      meta,
    },
  }, context)

  Cacher.page.set(context, uid, pr);

  return pr
}